import {AWSJSONValue} from '../types';

// FNP-536 / known billing-api gotcha: AWSJSON fields that store a pre-stringified value
// come back double- (sometimes triple-) encoded. A single JSON.parse leaves the inner
// string, so every nested field reads as undefined. Parse-until-object: repeatedly
// JSON.parse while the result is still a string, up to a small bound so a genuinely
// string-valued payload can't loop forever.
export const parseAwsJson = (value: AWSJSONValue | undefined): unknown => {
    if (value === null || value === undefined) {
        return null;
    }

    let current: unknown = value;
    for (let i = 0; i < 3; i++) {
        if (typeof current !== 'string') {
            break;
        }
        try {
            current = JSON.parse(current);
        } catch {
            // Not JSON (or no longer JSON) — return the string as-is.
            break;
        }
    }
    return current;
};

// Pretty-print the UsageEvent.attributes AWSJSON for display. Returns an empty string
// for a null/absent payload so the detail view can choose what to show.
export const prettyPrintAttributes = (value: AWSJSONValue | undefined): string => {
    const parsed = parseAwsJson(value);
    if (parsed === null) {
        return '';
    }
    if (typeof parsed === 'string') {
        return parsed;
    }
    try {
        return JSON.stringify(parsed, null, 2);
    } catch {
        return String(parsed);
    }
};
